import { App } from 'antd';

/**
 * Thin wrapper around antd's contextual message API (App.useApp().message).
 * Using the context-bound instance (not the static antd.message.* import)
 * means toasts correctly inherit the current ConfigProvider theme —
 * required since this app switches between light/dark at runtime.
 */
export const useAppMessage = () => App.useApp().message;
